import { ChangeDetectionStrategy, Component } from '@angular/core';
import { SectionHeaderComponent } from '@app/widgets/components';
import { TuiIcon } from '@taiga-ui/core';

@Component({
  selector: 'app-enterprise-security-section',
  imports: [TuiIcon, SectionHeaderComponent],
  templateUrl: './enterprise-security-section.component.html',
  styleUrl: './enterprise-security-section.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class EnterpriseSecuritySectionComponent {}
